<template>
  <div class="container-fluid">
    <Breadcrumb :values="{ Home: '/', 'Statistic Generator': 'statistics-generator' }"></Breadcrumb>
    <div class="animated fadeIn">
      <Loader :show="loadingData" />
      <div class="col-12 px-0 mb-4" v-if="showTabs">
        <RDFTabs
          :loading-data="loadingData"
          :rdf-data="rdfData"
          :download-file="downloadFile"
          :show-charts="showCharts"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RDFTabs from '@/components/RDFForms/RDFTabs'
import Loader from '@/components/shared/Loader.vue'
import Breadcrumb from '@/components/shared/Breadcrumb'

export default {
  name: 'RDFResultView',
  components: {
    RDFTabs,
    Loader,
    Breadcrumb
  },
  props: {
    showTabs: Boolean,
    loadingData: Boolean,
    rdfData: Object,
    downloadFile: Function,
    showCharts: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
@import url('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap');

.container-fluid {
  padding: 0 !important;
}

</style>
